import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../lib/shared/validators";
import { modulesTypes, actions } from "../../lib/config/validator";

/**
 * Re-exportar modulesTypes y actions para compatibilidad con código existente
 * Ahora se generan desde lib/config/validator
 */
export { modulesTypes, actions };

/**
 * Validator para la tabla de permisos
 * Define qué acciones puede realizar cada rol en cada módulo
 */
export const validatorPermissions = v.object({
  // new fields (didn't exist in old version)
  roleId: v.optional(v.id("roles")), // Rol específico
  module: modulesTypes, // Módulo (auto-generado desde ERP_MODULES_CONFIG)
  conditions: v.optional(v.any()), // Condiciones adicionales (ej: solo ciertos clientes)
  canRead: v.boolean(),
  canCreate: v.boolean(),
  canUpdate: v.boolean(),
  canDelete: v.boolean(),

  internalControl: internalControl,
});

/**
 * Tabla de permisos
 * Relaciona roles con módulos y define las acciones permitidas
 */
export const permissions = defineTable(validatorPermissions)
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_created_by_company_id", [
    "internalControl.createdBy",
    "internalControl.companyId",
  ])
  .index("by_created_by_company_id_branch_id", [
    "internalControl.createdBy",
    "internalControl.companyId",
    "internalControl.branchId",
  ])
  .index("by_module", ["module"])
  .index("by_company_id_role_id", ["internalControl.companyId", "roleId"])
  .index("by_company_id_role_id_module", [
    "internalControl.companyId",
    "roleId",
    "module",
  ]);
